import React, { useCallback } from 'react';
import { StyledNumericInput } from '@/components/mui/Form/TextField/StyledComponent';

// `allowLeadingZeros` also switches the emitted value from number to string —
// a number cannot carry a leading zero, so legacy consumers stay opted out (DPM-696).
const PhoneInput = React.forwardRef(({ value, onChange: inputOnChange, className, allowLeadingZeros, ...rest }, ref) => {
  const onChange = useCallback(
    (e) => {
      inputOnChange(allowLeadingZeros ? (e.value ?? '') : e.floatValue || null);
    },
    [inputOnChange, allowLeadingZeros],
  );

  return (
    <StyledNumericInput
      getInputRef={ref}
      decimalScale={0}
      allowLeadingZeros={allowLeadingZeros}
      allowNegative={false}
      value={value ?? ''}
      onValueChange={onChange}
      type="text"
      dir="ltr"
      className={className}
      {...rest}
    />
  );
});

export default React.memo(PhoneInput);
